<div fxLayout="row">
    <div class="course-step-content p-20" fxFlex="100">
        <ng-container>
            <div class="" fxLayout="column" fxLayoutAlign="start center">
                <h1> {{'PERFILES.USUARIO.TITULO_LOGIN' | translate}}</h1>
            </div>
        </ng-container>
        <table>
          <thead>
            <th>{{'PERFILES.USUARIO.TH-USUARIO' | translate}}</th>
            <th colspan="2">{{'PERFILES.USUARIO.TH-TUSUARIO' | translate}}</th>
          </thead>
          <tr *ngFor="let users of usuariosOrdenador">
            <td>{{users.user}}</td>
            <td>{{'PERFILES.USUARIO.NIVELES.'+users.level | translate}}</td>
            <td fxLayout="column" fxLayoutAlign="start stretch">
              <div fxLayout="row" fxLayoutAlign="end center">
                <button mat-raised-button color="black" (click)="autologin(users.user,users.password)">
                  {{'PERFILES.USUARIO.TH-LOGIN' | translate}}
                  <mat-icon class="ml-20">input</mat-icon>
                </button>
              </div>
            </td>

          </tr>


        </table>

        <!--<table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="width:100%">
            <ng-container matColumnDef="correo">
                <th mat-header-cell *matHeaderCellDef>
                </th>
                <td mat-cell *matCellDef="let element"> {{element.user}} </td>
            </ng-container>

            <ng-container matColumnDef="tipousu">
                <th mat-header-cell *matHeaderCellDef>
                </th>
                <td mat-cell *matCellDef="let element"> {{'PERFILES.USUARIO.NIVELES.'+element.level | translate}}</td>
            </ng-container>

            <ng-container matColumnDef="accion">
                <th mat-header-cell *matHeaderCellDef>

                </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container>
                        <button mat-raised-button class="mb-20" style="margin-top: 5px;" (click)="autologin(element.user,element.password)">
                            {{'PERFILES.USUARIO.TH-LOGIN' | translate}}
                        </button>
                    </ng-container>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>-->
        <!--{{'PERFILES.USUARIO.TH-USUARIO' | translate}}-->
        <!--{{'PERFILES.USUARIO.TH-TUSUARIO' | translate}}-->
        <!--{{'PERFILES.USUARIO.TH-ACCIONES' | translate}}-->
    </div>




</div>
